import React from 'react'

export default class OutState extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {
    this.props.onChangeCallback(e.target.checked)
  }

  render() {

    let purchase = this.props.purchase

    let inputValue = typeof purchase.is_igst !== "undefined" ? purchase.is_igst : false

    let check = <div> <input type="checkbox" checked={inputValue} onChange={this.handleChange} /></div>

    return <div>{check}</div>
  }
}


export class AddCess extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {
    this.props.onChangeCallback(e.target.checked)
  }

  render() {

    let purchase = this.props.purchase

    let inputValue = typeof purchase.add_cess !== "undefined" ? purchase.add_cess : false

    let check = <div> <input type="checkbox" checked={inputValue} onChange={this.handleChange} /></div>

    return <div>{check}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/outstate.js